export default __webpack_public_path__ + "static/media/slide20.2530f8dc.png";